// Display names for a company's ELD type. The backend values stay "custom" / "default";
// only what admins read changes. ("custom" used to be shown as "Legal".)
export const STANDARD_ELD = 'Standard ELD';
export const DEFAULT_ELD = 'Default ELD';

export const eldTypeLabel = (eldType?: string | null) =>
  eldType === 'custom' ? STANDARD_ELD : DEFAULT_ELD;
